<template>
  <div>
    <button @click="start" id="start">开始录制</button>
    <button @click="stop" id="stop">结束录制</button>
    <button @click="play" id="play">播放</button>
    <audio id="audio" controls></audio>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {
      mediaRecorder: null,
      audioChunks: []
    }
  },
  methods: {
    start() {
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then(stream => {
          this.mediaRecorder = new MediaRecorder(stream);

          this.mediaRecorder.ondataavailable = event => {
            this.audioChunks.push(event.data);
          };

          this.mediaRecorder.onstop = () => {
            const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
            const audioUrl = URL.createObjectURL(audioBlob);
            document.getElementById('audio').src = audioUrl;

            // Create a FormData object to send the audio file to the server
            const formData = new FormData();
            formData.append("audio", audioBlob, "recording.wav");
            // 打印文件大小
            console.log("File size: " + audioBlob.size / 1024 / 1024 + " MB");

            // Send the audio file to the backend
            this.uploadAudio(formData);
          };

          this.mediaRecorder.start();
          console.log('Recording started...');
        })
        .catch(err => {
          console.error('Error accessing microphone: ', err);
        });
    },
    stop() {
      this.mediaRecorder.stop();
      console.log('Recording stopped...');
    },
    play() {
      const audio = document.getElementById('audio');
      audio.play();
    },
    uploadAudio(formData) {
      console.log('Upload function not implemented', formData);
      return
      // fetch('https://your-backend-endpoint.com/upload', {
      //   method: 'POST',
      //   body: formData,
      // })
      //   .then(response => response.json())
      //   .then(data => {
      //     console.log('Upload successful:', data);
      //   })
      //   .catch(error => {
      //     console.error('Error uploading audio:', error);
      //   });
    }
  }
}
</script>

<style>
</style>